import { FancyBearMetadata } from "types";
import * as metadataApi from "api/metadataApi";
import useFetchPromise from "hooks/useFetchPromise";
import useCacheId from "hooks/useCacheId";
import { useMemo } from "react";

const useFetchMetadata = (tokenId?: number) => {
  const cacheId = useCacheId();
  const promise = useMemo(
    () => (data: number) => metadataApi.fetchMetadata(data, cacheId),
    [cacheId]
  );

  return useFetchPromise<FancyBearMetadata, number>(promise, tokenId);
};

export default useFetchMetadata;
